import React from 'react';

const ContactUs = () => {
  return (
    <div className="page-content">
      {/* Hero Section */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['phone', 'email', 'location_on', 'schedule', 'contact_support', 'chat', 'forum', 'message'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Get In Touch
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Contact Us
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Reach out with any questions - We're here to help
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Get In Touch</h2>
            <p>Customer service is our number one priority</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'start', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                If you have questions, comments or project requests for Bel-Aire Mechanical, please reach out for all of your needs. 
                <strong style={{color: 'var(--accent-blue)'}}> Customer service is our number one priority</strong>, so we promise you a 
                professional response from a friendly, knowledgeable member of our team.
              </p>
              
              <div style={{background: 'var(--secondary-light)', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
                <h3 style={{fontSize: '1.3rem', color: 'var(--accent-blue)', marginBottom: '1rem'}}>Contact Information</h3>
                
                <div style={{marginBottom: '1.5rem'}}>
                  <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                    <div style={{fontSize: '1.5rem', marginRight: '1rem', color: 'var(--accent-blue)'}}>
                      <span className="material-icons" style={{fontSize: 'inherit', color: 'inherit'}}>location_on</span>
                    </div>
                    <div>
                      <strong style={{color: 'var(--accent-blue)'}}>Address</strong><br />
                      <span style={{color: 'var(--gray-600)'}}>
                        4201 North 47th Avenue<br />
                        Phoenix, AZ 85031<br />
                      </span>
                    </div>
                  </div>
                  
                  <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                    <div style={{fontSize: '1.5rem', marginRight: '1rem', color: 'var(--accent-blue)'}}>
                      <span className="material-icons" style={{fontSize: 'inherit', color: 'inherit'}}>phone</span>
                    </div>
                    <div>
                      <strong style={{color: 'var(--accent-blue)'}}>Phone</strong><br />
                      <span style={{color: 'var(--gray-600)'}}>
                        (623) 846-8600<br />
                        <em style={{color: 'var(--accent2-red)'}}>24/7 Emergency Service Available</em>
                      </span>
                    </div>
                  </div>
                  
                  <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <div style={{fontSize: '1.5rem', marginRight: '1rem', color: 'var(--accent-blue)'}}>
                      <span className="material-icons" style={{fontSize: 'inherit', color: 'inherit'}}>schedule</span>
                    </div>
                    <div>
                      <strong style={{color: 'var(--accent-blue)'}}>Hours</strong><br />
                      <span style={{color: 'var(--gray-600)'}}>
                        Monday - Friday: 7:00 AM - 4:00 PM<br />
                        Saturday: Closed<br />
                        Sunday: Closed
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 style={{fontSize: '1.5rem', color: 'var(--accent-blue)', marginBottom: '1rem'}}>Visit Our Office</h3>
              <div style={{
                width: '100%',
                height: '400px',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent-blue)'
              }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3327.1234567890123!2d-112.1621322!3d33.4978949!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b14bbece4a997:0xd31565ef5ea0b342!2s4201%20N%2047th%20Ave%2C%20Phoenix%2C%20AZ%2085031!5e3!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus&t=k"
                  width="100%"
                  height="100%"
                  style={{border: 0}}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Bel-Aire Mechanical Office Location - 4201 North 47th Avenue, Phoenix, AZ 85031"
                ></iframe>
              </div>
              <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', marginTop: '1rem', textAlign: 'center'}}>
                <strong>Central Phoenix Location</strong><br />
                Easily accessible from all major highways
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ContactUs;
